import darkOrLightMode from '../../utils/helpers/colorMode';
import QISignTheme from '../../interfaces/Theme';
import * as S from './styles';

export const ThemedButton = ({ children, clientThemeSettings, ...props }: { children: React.ReactNode, clientThemeSettings: QISignTheme, [key: string]: any }) => {
    
    
    return (
        <S.MainButton
            $backgroundColor={clientThemeSettings.button_color}
            $textColor={clientThemeSettings.button_font_color ? clientThemeSettings.button_font_color : darkOrLightMode(clientThemeSettings.button_color) === 'light mode' ? '#232323' : '#FFFFFF'}
            $loading={props.$loading}
            $disabled={props.$disabled || props.$loading}
            onClick={props.$disabled || props.$onClick || props.$loading ? () => {} : props.$onClick}
            $type={props.type}
            {...props}
        >
            {children}
        </S.MainButton>
    );
};